import { SVButton } from '@/components/core';
import NeedAssistanceBox from '@/components/NeedAssistanceBox';
import { ROUTES } from '@/constants/routes';
import { Card, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ActivationExpired() {
  const navigate = useNavigate();

  return (
    <Card>
      <Stack spacing={2}>
        <Typography variant="h4">Activation Expired</Typography>
        <Typography>
          We are unable to activate your account because your activation link
          expired. Would you like us to resend a new activation link?
        </Typography>
        <SVButton
          variant="primary"
          type="submit"
          onClick={() => navigate(ROUTES.ACTIVATION_RESEND)}>
          Resend Activation Link
        </SVButton>
        <NeedAssistanceBox />
      </Stack>
    </Card>
  );
}
